import React, { useRef, useState, useEffect } from "react";
import { Button, Container, Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { GoogleLogin, GoogleOAuthProvider} from '@react-oauth/google';
import Alert from "../components/Alert";

import axios from "axios";
const Home = () => {
  const [error, setError] = useState(""); // Error state for feedback
  const [loading, setLoading] = useState(true); // Loading state to prevent flashing content

  const [functionError, setFunctionError] = useState("");
  const [functionSuccess, setFunctionSuccess] = useState("");
  
  const navigate = useNavigate(); // For navigation after login

  

  const emailRef = useRef(); // Email input ref
  const passwordRef = useRef(); // Password input ref
  const resetEmailRef = useRef(); // Reset email input ref
  const [showResetForm, setShowResetForm] = useState(false);
  const [resetToken, setResetToken] = useState("");
  const newPasswordRef = useRef();
  const confirmPasswordRef = useRef();

  // Check for reset token in URL on component mount
  useEffect( () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      setResetToken(token);
      setShowResetForm(true);
    }
  }, []);

  const successMessage = async (response) => {
	const tokenId = response.credential;
  
	
  
	try {
	  axios.post(
		'https://api.viralgpt.com/auth/google',
		{ token: tokenId },
		{
		  headers: {
			'Content-Type': 'application/json',
			'Accept': 'application/json'
		  },
		  withCredentials: true
		}
	  )
	  .then(response => {
		console.log('Success:', response.data);
		// Store JWT token
		localStorage.setItem('accessToken', response.data.accessToken);
        // Redirect user after successful login
        navigate('/dashboard');
	  })
	  .catch(error => console.error('Error:', error.response ? error.response.data : error.message));
	} catch (error) {
	  console.error('Login error', error);
	}
  };
  

const errorMessage = (error) => {
	console.log('Login failed:', error);
};

  // Handle password reset submission
  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setError("");

    if (newPasswordRef.current.value !== confirmPasswordRef.current.value) {
      setFunctionError("Passwords do not match");
      return;
    }

    try {
      const response = await axios.post("https://api.viralgpt.com/auth/reset-password", {
        token: resetToken,
        newPassword: newPasswordRef.current.value
      });

      setShowResetForm(false);
      setFunctionSuccess("Password reset successful. Please login with your new password.");

    } catch (err) {
      setFunctionError(err.response?.data?.error || "An error occurred. Please try again.");
    }
  };

  // Reset password form JSX
  const resetPasswordForm = (
    <Form onSubmit={handlePasswordReset}>
      <Form.Group className="mb-3">
        <Form.Label>New Password</Form.Label>
        <Form.Control
          type="password"
          ref={newPasswordRef}
          required
          placeholder="Enter new password"
        />
        <small className="text-muted">Password must be at least 8 characters long</small>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Confirm Password</Form.Label>
        <Form.Control
          type="password"
          ref={confirmPasswordRef}
          required
          placeholder="Confirm new password"
        />
      </Form.Group>

      <Button type="submit" className="w-100">
        Reset Password
      </Button>
    </Form>
  );



  // Validate token
  const checkAuthentication = async () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return false; // No token, not authenticated

    try {
      const response = await fetch("https://api.viralgpt.com/auth/validate", {
        method: "POST",
		credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`
        },
        body: JSON.stringify({ token: accessToken }),
      });

      if (response.ok) {
        // If validation successful, ensure token is still in localStorage
        if (!localStorage.getItem("accessToken")) {
          localStorage.setItem("accessToken", accessToken);
        }
        return true;
      } else {
        // If token is invalid, remove it
        localStorage.removeItem("accessToken");
        return false;
      }
    } catch (err) {
      console.error("Authentication check failed:", err);
      return false;
    }
  };

  // Handle login form submission
  const login = async (e) => {
    e.preventDefault();
    setError(""); // Clear previous errors

    try {
      const response = await axios.post("https://api.viralgpt.com/auth/login", {
        email: emailRef.current.value,
        password: passwordRef.current.value
      }, {
        withCredentials: true
      });

      // With axios, response.data contains the parsed response body
      const { accessToken } = response.data;

      // Save token and navigate to dashboard
      localStorage.setItem("accessToken", accessToken);
      navigate("/dashboard");

    } catch (err) {
      console.error("Login error:", err);
      // Handle axios error response
      const errorMessage = err.response?.data?.error || "An error occurred. Please try again.";
      setError(errorMessage);
    }
  };

  // Redirect to dashboard if already logged in
  useEffect(() => {
    const redirectIfAuthenticated = async () => {
      const isAuthenticated = await checkAuthentication();
      if (isAuthenticated) {
        navigate("/dashboard"); // Redirect if already logged in
      } else {
        setLoading(false); // Stop loading if not logged in
      }
    };

    redirectIfAuthenticated();
  }, [navigate]);

  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  const resetPassword = () => {
    setShowModal(true);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    try {
		const response = await fetch("https://api.viralgpt.com/auth/request-reset", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				email: resetEmailRef.current.value,
			}),
		});
		if (response.ok) {
			setFunctionSuccess("Reset instructions sent to email");
		} else {
			setFunctionError("Failed to send reset instructions");
		}	
	} catch (err) {
		console.error("Reset password error:", err);
		setFunctionError("An error occurred. Please try again.");
	}
  };

  // Show loading spinner while checking authentication
  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}>Loading...</div>;
  }

  return (
    <div>
	<h3 className="m-2">
		<a href="/" className="text-decoration-none">
			<span className="text-2xl font-semibold text-gray-900 d-flex align-items-center">
				<img 
					src="/images/logo-icon.png" 
					alt="Logo" 
					style={{width: '30px', height: '30px', marginRight: '8px'}} 
				/>
				<span className="text-instagram">ViralGPT</span>
			</span>
		</a>
	</h3>

    <Alert 
      variant="danger" 
      message={functionError} 
      show={!!functionError} 
      onClose={() => setFunctionError("")} 
    />
        
    <Alert 
      variant="success" 
      message={functionSuccess} 
      show={!!functionSuccess} 
      onClose={() => setFunctionSuccess("")} 
    />

		{showResetForm && (
			<Modal show={showResetForm} onHide={() => setShowResetForm(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Reset Your Password</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{resetPasswordForm}
				</Modal.Body>
			</Modal>
		)}

	  <Modal show={showModal} onHide={handleCloseModal} centered>
		<Modal.Header closeButton>
			<Modal.Title>Reset Your Password</Modal.Title>
		</Modal.Header>
		<Modal.Body>
			<p className="text-muted mb-4">
				Enter your email address and we'll send you instructions to reset your password.
			</p>
			<Form>
				<Form.Group className="mb-4" controlId="resetEmail">
					<Form.Label>Email Address</Form.Label>
					<Form.Control 
						type="email" 
						placeholder="name@example.com"
						className="form-control-lg" 
						ref={resetEmailRef}
					/>
				</Form.Group>
				<div className="d-grid">
					<Button 
						variant="primary" 
						type="submit"
						size="lg"
						className="bg-instagram"
						onClick={handleResetPassword}
					>
						Send Reset Instructions
					</Button>
				</div>
			</Form>
		</Modal.Body>
	  </Modal>
      <Container className="justify-content-center text-center max-w-lg mt-12" fluid>

        <Alert 
          variant="danger" 
          message={"email_pass_login"} 
          show={!!error} 
          onClose={() => setError("")} 
        />   

        <Form onSubmit={login} className="bg-white shadow-lg p-4 mt-12">
          <h1 className="font-bold text-instagram">Welcome Back</h1>
          <small className="text-muted">
            Sign in using your email and password to access the dashboard.
          </small>
          <Form.Group className="mb-3 mt-6" controlId="formBasicEmail">
            <Form.Control ref={emailRef} type="email" placeholder="Enter email" required />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Control ref={passwordRef} type="password" placeholder="Password" required />
          </Form.Group>

          <Button variant="primary" type="submit" className="bg-instagram w-full">
            Login
          </Button>
		  <br></br> <br></br>
		  <center>
		  <GoogleOAuthProvider clientId="255966676242-fhjo5pkp2eo7argo8oghm2u5u16253uk.apps.googleusercontent.com">
            <GoogleLogin
                onSuccess={successMessage}
                onError={errorMessage}
            />
        </GoogleOAuthProvider>
		</center>
		  <small className="d-block text-muted mt-6 cursor-pointer">
		  <span onClick={resetPassword} className="font-bold"> Forgot your password? </span>
		  </small>
        </Form>
		<small className="d-block text-muted mt-6 font-bold">
          Don't have a plan? <a className="text-primary" href="/pricing">Purchase a plan</a>
        </small>


      </Container>
    </div>
  );
};

export default Home;
